export default __webpack_public_path__ + "static/fondoModalSorry-4560ec0e9a3a4ba164f74e7e32d4df16.png";